import {Helmet} from 'react-helmet-async';
// import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const About = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Communitism | About</title>
                <meta name="description"
                      content="Learn more about the Communitism Project and our community initiatives."/>
                <meta property="og:title" content="Communitism | About" key="ogtitle"/>
                <meta property="og:description"
                      content="Discover more about the Communitism Project, our mission, and how to get involved."
                      key="ogdesc"/>
                <meta property="og:url" content="https://heriscope.communitism.space/about"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>

            {/* Icon Section */}
            <div className='simple-page contact-page-container'>
                <div className='row justify-content-center'>

                    <div className="content-area">
                        <h1 className="content-title">{t("Σχετικά με το HeriScope")}</h1>
                        <div className="content-text">
                            <p> Ένας ψηφιακός χώρος για τα κτίρια πολιτιστικής κληρονομιάς της πόλης μας</p>
                            <p>Το HeriScope γεννήθηκε μέσα από το εργαστήρι Παντός Καιρού, μια συλλογική προσπάθεια
                                χαρτογράφησης και καταγραφής των κτιρίων σε αχρησία στο Μεταξουργείο. Το εργαστήρι
                                συνδιοργανώθηκε από το Communitism, την ΚοινΣΕπ Μυκήλιο και την πρωτοβουλία Recual
                                (Recycling Ecological Collaborative Urban Architecture Laboratory), φέρνοντας κοντά
                                ειδικούς, κατοίκους και δημιουργικ@ επαγγελματίες για να συνδιαμορφώσουν λύσεις για την
                                επανάχρηση αυτών των κτιρίων.</p>
                            <p>Η μικτή ομάδα του εργαστηρίου χαρτογράφησε και κατέγραψε την κατάσταση των κτιρίων του
                                Μεταξουργείου σε αχρησία, ενώ μέσω SWOT analysis διερεύνησε πιθανούς τρόπους
                                επανάχρησης, όπως συστέγαση, καλλιτεχνικά δρώμενα, και άλλες κοινωφελείς χρήσεις. Το
                                HeriScope έρχεται να υλοποιήσει τα ευρήματα αυτού του εργαστηρίου, προσφέροντας ένα
                                ανοιχτό εργαλείο καταγραφής και δικτύωσης των ενδιαφερόμενων μερών.</p>
                            <p>Καθώς η πόλη αλλάζει, πολλά κτίρια πολιτιστικής κληρονομιάς μένουν εγκαταλελειμμένα,
                                στερώντας από τις κοινότητες πολύτιμους χώρους. Με το HeriScope θέλουμε να
                                δημιουργήσουμε μια ανοιχτή βάση δεδομένων, όπου καθένας και καθεμία μπορεί να
                                συνεισφέρει, να μοιραστεί γνώσεις, να συνδεθεί με άλλ@ ενδιαφερόμεν@ και να αναζητήσει
                                λύσεις.</p>
                            <p>Το HeriScope είναι ένα από τα έργα του Communitism, μιας ένωσης πολιτών που ιδρύθηκε το
                                2017 με στόχο τη διάσωση της ιστορικής φυσιογνωμίας του Μεταξουργείου και τη μετατροπή
                                των κτιρίων σε αχρησία σε ανοιχτούς κοινωνικοπολιτιστικούς χώρους. Η γνώση που
                                αποκτήσαμε από τη μακρόχρονη παραμονή μας στο νεοκλασικό της Κεραμεικού 28 και η
                                εμπειρία μας από συνεργασίες με αντίστοιχες ευρωπαϊκές πρωτοβουλίες διαμόρφωσαν το όραμά
                                μας για αυτό τον ψηφιακό χώρο.</p>
                            <p>Το εγχείρημα αυτό δε θα είχε γίνει πραγματικότητα χωρίς τη συμμετοχή όλ@ν όσ@ αφιέρωσαν
                                χρόνο, γνώσεις και ενέργεια. Ευχαριστούμε θερμά όλ@ τ@ συμμετέχοντ@ που συνέβαλαν στη
                                δημιουργία του HeriScope!</p>
                            <p className="content-special-message">Η δράση υλοποιείται με την υποστήριξη του Helidoni Foundation στο πλαίσιο του προγράμματος
                                «Σημεία Στήριξης» που συγχρηματοδοτούν 10 κοινωφελείς οργανισμοί.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default About;
